'use client';
import * as React from 'react';
import { useTranslations } from 'next-intl';
import { CheckboxField } from '@/components/ui/field';

/** LGPD signup consent row (Termos + Privacidade links), shared by the login
 *  page's signup form and the guest booking checkout so the legally significant
 *  copy can never diverge between the two signup surfaces. */
export function ConsentCheckbox({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) {
  const t = useTranslations('auth');
  return (
    <CheckboxField
      name="terms"
      required
      checked={checked}
      onChange={onChange}
      className="items-start gap-2 text-[0.78125rem] leading-snug text-muted-foreground"
      label={
        <span>
          {t('consentPrefix')}{' '}
          <a href="/terms" target="_blank" className="underline hover:text-foreground">
            {t('consentTerms')}
          </a>{' '}
          {t('consentAnd')}{' '}
          <a href="/privacy" target="_blank" className="underline hover:text-foreground">
            {t('consentPrivacy')}
          </a>
          {t('consentSuffix')}
        </span>
      }
    />
  );
}
